<template>
  <form @submit="onSubmit">
      <div class="input-group mb-4">
          <input
            id="termo"
            v-model="form.termo"
            type="text"
            :disabled="$wait.is('dublador.load')"
            placeholder="Pesquise pelo nome ou filme.."
            class="form-control"
            name="termo">
            <div class="input-group-append">
              <base-button tag="button" nativeType="submit"
                  class=""
                  type="success"
                  :disabled="$wait.is('dublador.load')"
                  icon="fa fa-search">
                  Pesquisar
              </base-button>
            </div>
      </div>
  </form>
</template>
<script>
export default {
    data() {
      return {
        form: {
          termo: ( !this.$route.query.termo ) ? '' : this.$route.query.termo,
        }
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        // nao passaremos nenhum outro parametro para zerar a query da rota, de modo a resetar as demais opcoes do formulario
        if ( this.form.termo !== this.$route.query.termo ) {
          this.$router.push({ name: this.$route.name, query: { ...this.$route.query, termo: this.form.termo, pagina: 1 } })
        }
      }
    },
};
</script>
<style>
</style>
